import * as ActionTypes from '../ActionTypes';

export const GetOptionalHolidayCalendarAction = (params) => {
    return {
        type: ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_GET_REQUEST,
        params
    }
}

export const UpsertOptionalHolidayCalendarAction = (params) => {
    return {
        type: ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_UPSERT_REQUEST,
        params
    }
}

export const DeleteOptionalHolidayCalendarAction = (params) => {
    return {
        type: ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_DELETE_REQUEST,
        params
    }
}

export const GetEmployeeOptionalHolidayCalendarAction = (params) => {
    return {
        type: ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_GET_REQUEST,
        params
    }
}

export const UpsertEmployeeOptionalHolidayCalendarAction = (params, callback) => {
    return {
        type: ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_UPSERT_REQUEST,
        params,
        callback
    }
}

export const DeleteEmployeeOptionalHolidayCalendarAction = (params) => {
    return {
        type: ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_DELETE_REQUEST,
        params
    }
}
